export default (theme) => ({
  infoIcon: {
    fill: theme.palette.secondary.main,
    maxWidth: 18,
    width: '100%',
    height: 'auto',
  },
});
